import React from "react";
import { Routes, Route } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import Home from "../pages/public/Home/Home";
import About from "../pages/public/About/About";
import Directory from "../pages/public/Directory/Directory";
import Events from "../pages/public/Events/Events";
import Notices from "../pages/public/Notices/Notices";
import Business from "../pages/public/Business/Business";
import Amenities from "../pages/public/Amenities/Amenities";
import Gallery from "../pages/public/Gallery/Gallery";
import Contact from "../pages/public/Contact/Contact";
import Login from "../pages/auth/Login/Login";
import ForgotPassword from "../pages/auth/ForgotPassword/ForgotPassword";
import Privacy from "../pages/public/Privacy/Privacy";
import Terms from "../pages/public/Terms/Terms";
import NotFound from "../pages/public/NotFound/NotFound";

import AdminLayout from "../layouts/AdminLayout/AdminLayout";
import ResidentLayout from "../layouts/ResidentLayout/ResidentLayout";
import SecurityLayout from "../layouts/SecurityLayout/SecurityLayout";
import SuperadminLayout from "../layouts/SuperadminLayout/SuperadminLayout";

import AdminDashboard from "../AdminDashboard/Dashboard/AdminDashboard";
import AdminResidents from "../AdminDashboard/Residents/Residents";
import AdminVisitors from "../AdminDashboard/Visitors/Visitors";
import AdminVehicles from "../AdminDashboard/Vehicles/Vehicles";
import AdminNotices from "../AdminDashboard/Notices/Notices";
import AdminEvents from "../AdminDashboard/Events/Events";
import AdminComplaints from "../AdminDashboard/Complaints/Complaints";
import AdminMaintenance from "../AdminDashboard/Maintenance/Maintenance";
import AdminPayments from "../AdminDashboard/Payments/Payments";
import AdminAmenities from "../AdminDashboard/Amenities/Amenities";
import AdminDocuments from "../AdminDashboard/Documents/Documents";
import AdminGallery from "../AdminDashboard/Gallery/Gallery";
import AdminBusiness from "../AdminDashboard/Business/Business";
import AdminNotifications from "../AdminDashboard/Notifications/Notifications";
import AdminReports from "../AdminDashboard/Reports/Reports";
import AdminPolls from "../AdminDashboard/Polls/AdminPolls";
import AdminSettings from "../AdminDashboard/Settings/Settings";
import AdminSecurityLogs from "../AdminDashboard/SecurityLogs/SecurityLogs";
import AdminProfile from "../AdminDashboard/Profile/AdminProfile";
import AdminGatePasses from "../AdminDashboard/GatePasses/GatePasses";
import AdminSuggestions from "../AdminDashboard/Suggestions/AdminSuggestions";
import AdminSecurityStaff from "../AdminDashboard/SecurityStaff/SecurityStaff";
import AdminCommittee from "../AdminDashboard/Committee/Committee";

import SuperadminDashboard from "../SuperadminDashboard/Dashboard/SuperadminDashboard";
import SuperadminAdmins from "../SuperadminDashboard/Admins/Admins";
import SuperadminProfile from "../SuperadminDashboard/Profile/SuperadminProfile";
import SuperadminSettings from "../SuperadminDashboard/Settings/Settings";
import Businesses from "../SuperadminDashboard/Businesses/Businesses";
import BusinessPromoRequests from "../SuperadminDashboard/BusinessPromo/BusinessPromoRequests";
import AuditLogs from "../SuperadminDashboard/AuditLogs/AuditLogs";
import ResidentDashboard from "../UserDashboard/Dashboard/ResidentDashboard";
import MyProfile from "../UserDashboard/Profile/MyProfile";
import MyFamily from "../UserDashboard/Family/MyFamily";
import ResidentNotices from "../UserDashboard/Notices/ResidentNotices";
import ResidentEvents from "../UserDashboard/Events/ResidentEvents";
import Complaints from "../UserDashboard/Complaints/Complaints";
import Maintenance from "../UserDashboard/Maintenance/Maintenance";
import Visitors from "../UserDashboard/Visitors/Visitors";
import MyVehicles from "../UserDashboard/Vehicles/MyVehicles";
import ResidentAmenities from "../UserDashboard/Amenities/Amenities";
import Documents from "../UserDashboard/Documents/Documents";
import MyBusiness from "../UserDashboard/Business/MyBusiness";
import MyGatePass from "../UserDashboard/GatePass/MyGatePass";
import Notifications from "../UserDashboard/Notifications/Notifications";
import Settings from "../UserDashboard/Settings/Settings";
import ResidentPolls from "../UserDashboard/Polls/ResidentPolls";
import EmergencyContacts from "../UserDashboard/Emergency/EmergencyContacts";
import SecurityDashboard from "../SecurityDashboard/Dashboard/SecurityDashboard";
import SecurityVisitors from "../SecurityDashboard/Visitors/Visitors";
import SecurityGatePass from "../SecurityDashboard/GatePass/GatePass";
import SecurityDeliveries from "../SecurityDashboard/Deliveries/Deliveries";
import SecurityVehicles from "../SecurityDashboard/Vehicles/Vehicles";
import SecurityAttendance from "../SecurityDashboard/Attendance/Attendance";
import SecurityPatrolling from "../SecurityDashboard/Patrolling/Patrolling";
import SecurityIncidents from "../SecurityDashboard/Incidents/Incidents";
import SecurityEmergency from "../SecurityDashboard/Emergency/Emergency";
import SecurityNotifications from "../SecurityDashboard/Notifications/Notifications";
import SecurityCameras from "../SecurityDashboard/Cameras/Cameras";
import SecuritySettings from "../SecurityDashboard/Settings/Settings";
import SecurityProfile from "../SecurityDashboard/Profile/SecurityProfile";
import SecurityDirectory from "../SecurityDashboard/Directory/Directory";

import ProtectedRoute from '../components/common/ProtectedRoute/ProtectedRoute';

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="/events" element={<Events />} />
        <Route path="/notices" element={<Notices />} />
        <Route path="/business" element={<Business />} />
        <Route path="/amenities" element={<Amenities />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Dashboard Routes */}
      <Route path="/admin" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<AdminDashboard />} />
        <Route path="profile" element={<AdminProfile />} />
        <Route path="residents" element={<AdminResidents />} />
        <Route path="visitors" element={<AdminVisitors />} />
        <Route path="vehicles" element={<AdminVehicles />} />
        <Route path="notices" element={<AdminNotices />} />
        <Route path="events" element={<AdminEvents />} />
        <Route path="complaints" element={<AdminComplaints />} />
        <Route path="maintenance" element={<AdminMaintenance />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="amenities" element={<AdminAmenities />} />

        <Route path="documents" element={<AdminDocuments />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="business" element={<AdminBusiness />} />
        <Route path="gate-passes" element={<AdminGatePasses />} />
        <Route path="security-logs" element={<AdminSecurityLogs />} />
        <Route path="security-staff" element={<AdminSecurityStaff />} />
        <Route path="committee" element={<AdminCommittee />} />
        <Route path="polls" element={<AdminPolls />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="suggestions" element={<AdminSuggestions />} />
        <Route path="*" element={<AdminDashboard />} />
      </Route>

      <Route path="/resident" element={
        <ProtectedRoute allowedRoles={['resident']}>
          <ResidentLayout />
        </ProtectedRoute>
      }>
        <Route index element={<ResidentDashboard />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="family" element={<MyFamily />} />
        <Route path="notices" element={<ResidentNotices />} />
        <Route path="events" element={<ResidentEvents />} />
        <Route path="complaints" element={<Complaints />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="visitors" element={<Visitors />} />
        <Route path="vehicles" element={<MyVehicles />} />
        <Route path="amenities" element={<ResidentAmenities />} />
        <Route path="documents" element={<Documents />} />
        <Route path="business" element={<MyBusiness />} />
        <Route path="gate-pass" element={<MyGatePass />} />
        <Route path="polls" element={<ResidentPolls />} />
        <Route path="emergency" element={<EmergencyContacts />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="/security" element={
        <ProtectedRoute allowedRoles={['security']}>
          <SecurityLayout />
        </ProtectedRoute>
      }>
        <Route index element={<SecurityDashboard />} />
        <Route path="profile" element={<SecurityProfile />} />
        <Route path="directory" element={<SecurityDirectory />} />
        <Route path="visitors" element={<SecurityVisitors />} />
        <Route path="gate-pass" element={<SecurityGatePass />} />
        <Route path="deliveries" element={<SecurityDeliveries />} />
        <Route path="vehicles" element={<SecurityVehicles />} />
        <Route path="attendance" element={<SecurityAttendance />} />
        <Route path="patrolling" element={<SecurityPatrolling />} />
        <Route path="incidents" element={<SecurityIncidents />} />
        <Route path="emergency" element={<SecurityEmergency />} />
        <Route path="notifications" element={<SecurityNotifications />} />
        <Route path="cameras" element={<SecurityCameras />} />
        <Route path="settings" element={<SecuritySettings />} />
        <Route path="*" element={<SecurityDashboard />} />
      </Route>

      {/* Superadmin Routes */}
      <Route path="/superadmin" element={
        <ProtectedRoute allowedRoles={['superadmin']}>
          <SuperadminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<SuperadminDashboard />} />
        <Route path="admins" element={<SuperadminAdmins />} />
        <Route path="businesses" element={<Businesses />} />
        <Route path="business-promo-requests" element={<BusinessPromoRequests />} />
        <Route path="complaints" element={<AdminComplaints />} />
        <Route path="maintenance" element={<AdminMaintenance />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="vehicles" element={<AdminVehicles />} />
        <Route path="gate-passes" element={<AdminGatePasses />} />
        <Route path="security-logs" element={<AdminSecurityLogs />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="profile" element={<SuperadminProfile />} />
        <Route path="settings" element={<SuperadminSettings />} />

        {/* Inherited from Admin */}
        <Route path="residents" element={<AdminResidents />} />
        <Route path="visitors" element={<AdminVisitors />} />
        <Route path="notices" element={<AdminNotices />} />
        <Route path="events" element={<AdminEvents />} />
        <Route path="amenities" element={<AdminAmenities />} />
        <Route path="documents" element={<AdminDocuments />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="security-staff" element={<AdminSecurityStaff />} />
        <Route path="committee" element={<AdminCommittee />} />
        <Route path="polls" element={<AdminPolls />} />
        <Route path="suggestions" element={<AdminSuggestions />} />

        <Route path="*" element={<SuperadminDashboard />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;